// extracted by mini-css-extract-plugin
export default {"container":"style_container__-8Vmk","card":"style_card__DBrms","row":"style_row__i8Ma1","btnsRow":"style_btnsRow__IislK"};